import {
    Component,
    ElementRef,
    inject,
    OnDestroy,
    OnInit,
    signal,
    TemplateRef,
    viewChild,
    ViewChild,
    ViewContainerRef,
    ViewRef
} from "@angular/core";
import {AddressService} from "../../address.service";
import {NgbAlertModule, NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {debounceTime, Subscription, take, takeLast} from "rxjs";
import {AddressComponent, AddressValidationResult} from "../../../../models/types/address-types";
import {CommonModule, JsonPipe, KeyValuePipe} from "@angular/common";
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    FormRecord,
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";
import {FormControlComponent} from "../../../../lead-component/form-components/formcontrol/formcontrol.component";

@Component({
    selector: "app-address-modal",
    imports: [NgbAlertModule, FormsModule, ReactiveFormsModule, CommonModule],
    templateUrl: "./address.component.html",
    styleUrl: "./address.component.scss"
})
export class AddressModalComponent implements OnInit, OnDestroy {
    private addressService = inject(AddressService);
    private modalService = inject(NgbModal);
    private formBuilder = inject(FormBuilder);
    private subscriptions: Subscription[] = [];
    private modalRef?: NgbModalRef;
    @ViewChild("addressModalContent", {static: true, read: TemplateRef}) modalContent!: TemplateRef<any>;
    addressResult?: AddressValidationResult | null;
    addressCorrectionRequired: boolean = false;

    addressInputForm = this.formBuilder.group({
        addressInput: new FormControl("", {validators: [Validators.required, Validators.minLength(5)]})
    });

    validateAddress() {
        if (this.addressInputForm.controls.addressInput.valid) {
            const validationSub = this.addressService
                .validateAddress({unformattedAddress: this.addressInputForm.controls.addressInput.value!}, true)
                .subscribe((result) => {
                    this.addressCorrectionRequired = !result.addressVerdict?.isComplete;
                });
        }
    }

    confirm() {
        this.addressService.confirmUserAddressChoice(this.addressResult?.addressVerdict?.recommended);
        this.modalRef?.close();
    }

    ngOnInit(): void {
        const modalState$ = this.addressService.getModalState().subscribe((show) => {
            if (show) {
                this.modalRef = this.modalService.open(this.modalContent, {backdrop: "static", keyboard: false});
            } else {
                this.modalRef?.close();
            }
        });
        const validationResult$ = this.addressService.getValidationResults().subscribe((result) => {
            this.addressResult = result;
            this.addressCorrectionRequired = !result?.addressVerdict?.isComplete;
            this.addressInputForm.controls.addressInput.setValue(result?.address.unformattedAddress!);
        });

        this.subscriptions.push(modalState$, validationResult$);
    }
    ngOnDestroy(): void {
        console.log("destroy called");
        this.modalRef?.close();
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
